<div class="card h-100">
  <div class="card-header py-3">
    {{ data.title }}
  </div>
  <div class="card-body">
    <form [formGroup]="form">
      <mat-form-field class="w-100">
        <mat-label>Report Category</mat-label>
        <mat-select formControlName="reportCategory">
          <mat-option *ngFor="let category of reportCategories$ | async"
                      [value]="category.value">{{ category.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="d-flex gap-3">
        <div style="flex: 1">
          <label class="mb-2">Branch Codes</label>
          <ng-multiselect-dropdown
            (onDeSelect)="onItemDeSelect($event)"
            (onSelect)="onItemSelect($event)"
            [disabled]="true"
            [placeholder]="'Select Branch Code'"
            [settings]="dropdownSettings"
            [data]="branchOptions"
            formControlName="branch"
            name="branch">
          </ng-multiselect-dropdown>
        </div>

        <div style="flex: 1">
          <label class="d-flex justify-content-between mb-2">Menu <small>Limit 10</small></label>
          <ng-multiselect-dropdown
            (onDeSelect)="onMenuDeSelect($event)"
            (onSelect)="onMenuSelect($event)"
            [disabled]="disabledDropDownMenu"
            [placeholder]="'Search Menu'"
            [settings]="dropdownMenuSettings"
            [data]="menuOptions"
            formControlName="menu"
            name="menu">
          </ng-multiselect-dropdown>
        </div>
      </div>

    </form>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-end w-100 gap-1">
      <button (click)="onNoClick()" color="warn" mat-button>No</button>
      <button (click)="onClickOk()" [disabled]="onDisableButtonApply()" color="primary" mat-button>
        Ok
      </button>
    </div>
  </div>
</div>
